import React from "react";
import "./OpportunitySection.css";
import Common_Title from "../../common_components/common_title/Common_Title";

function OpportunitySection() {
  const data = [
    {
      label: <>INDIA'S <br/>POPULATION</>,
      count: "145",
      unit: "CRORE+",
    },
    {
      label: "RATIO OF GROSS ENROLLMENT IN INDIA",
      count: "28.4",
      unit: "",
    },
    {
      label: "AIM TO ACHIEVE GER RATIO BY 2035",
      count: "50%",
      unit: " IN HIGHER EDUCATION",
    },
    {
      label: "ONLINE HIGHER EDUCATION MARKET GROWING BY",
      count: "40%",
      unit: "Y-O-Y",
    },
  ];

  return (
    <div className="cyf_opportunity_section">
      <div className="container">
        <div className="title_holder">
          <Common_Title
            simpleText="Opportunities "
            darkText="For Profcyma Partner"
          />
        </div>
        <div className="cyf_opportunity_grid">
          <div className="row">
            {data?.map((item) => {
              return (
                <div className="col-md-3 col-6">
                  <div className="cyf_op_box">
                    <h6>{item?.label}</h6>
                    <h1>{item?.count}</h1>
                    <p>{item?.unit}</p>
                  </div>
                </div>
              );
            })}

            {/* <div className="col-md-3 col-6">
              <div className="cyf_op_box">
                <h6>Gross Enrollment Ratio in India</h6>
                <h1>28.4</h1>
                <p>sdfsdf</p>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="cyf_op_box">
                <h6>Gross Enrollment Ratio in India</h6>
                <h1>28.4</h1>
                <p>sdfsdf</p>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="cyf_op_box">
                <h6>Gross Enrollment Ratio in India</h6>
                <h1>28.4</h1>
                <p>sdfsdf</p>
              </div>
            </div> */}

          </div>
        </div>
      </div>
    </div>
  );
}

export default OpportunitySection;
